interface StructuredDataProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'BreadcrumbList' | 'Article' | 'FAQPage';
  data: Record<string, unknown>;
}

export default function StructuredData({ type, data }: StructuredDataProps) {
  const ldJson = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': type,
    ...data,
  });

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: ldJson }}
    />
  );
}